let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7aUO7")).then(() => parcelRequire('aYolq'));